// Presentation helpers for restaurant opening hours.
// All open/closed decisions come from the server (`restaurant.schedule`); this only formats them.
export const DAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

const DAY_NAMES = {
  sr: { monday: "Ponedeljak", tuesday: "Utorak", wednesday: "Sreda", thursday: "Četvrtak", friday: "Petak", saturday: "Subota", sunday: "Nedelja" },
  en: { monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday", sunday: "Sunday" },
};

export const dayName = (key, locale) => (DAY_NAMES[locale === "en" ? "en" : "sr"][key] || key);

export const todayKey = () => DAY_KEYS[(new Date().getDay() + 6) % 7];

export function dayHoursLabel(oh, locale) {
  const closedTxt = locale === "en" ? "Closed" : "Zatvoreno";
  if (!oh || oh.closed) return closedTxt;
  const periods = Array.isArray(oh.periods) && oh.periods.length ? oh.periods : [oh];
  const parts = periods.filter((p) => p.open && p.close).map((p) => `${p.open}–${p.close}`);
  return parts.length ? parts.join(", ") : closedTxt;
}

/** Contextual one-liner: "Zatvara se u 00:00" / "Otvara se u 12:00" / "Otvara se sutra u 12:00". */
export function scheduleLine(schedule, t, locale) {
  if (!schedule) return null;
  if (schedule.state === "open" && schedule.closes_at) {
    return t("hours.closes_at", "Zatvara se u {time}").replace("{time}", schedule.closes_at);
  }
  if (!schedule.opens_at) return null;
  const d = schedule.opens_in_days;
  if (d === 0) return t("hours.opens_at", "Otvara se u {time}").replace("{time}", schedule.opens_at);
  if (d === 1) return t("hours.opens_tomorrow", "Otvara se sutra u {time}").replace("{time}", schedule.opens_at);
  return t("hours.opens_on_day", "Otvara se u {day} u {time}")
    .replace("{day}", dayName(schedule.opens_weekday, locale))
    .replace("{time}", schedule.opens_at);
}
